// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children: string | React.Node,
  onClick: () => void,
};

const StyledButton = styled.button`
  width: 100%;
  text-align: center;
  background-color: transparent;
  padding: 8px 8px 16px;
  background-repeat: no-repeat;
  border: none;
  cursor:pointer;
  overflow: hidden;
  outline:none;
`;

const StyledSmall = styled.small`
  :hover { color: #000; }
  font-family: InterRegular;
  margin: 0;
  color: #4b4b4b;
`;


export default function ButtonFinePrint(props: TProps): React.Node {
  return (
    <StyledButton onClick={props.onClick}>
      <StyledSmall {...props}>
        {props.children}
      </StyledSmall>
    </StyledButton>
  );
}
